import type { Template } from "@/types";

export const SQ_01_H1_V0: Template[] = [
    {
        id: "sq-01-h1v0-01",
        name: "SQ 01 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_01.png",    
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 60, y: 159, width: 600, height: 400, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h1v0-02",
        name: "SQ 02 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 777, y: 159, width: 600, height: 400, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h1v0-03",
        name: "SQ 03 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 109, y: 71, width: 1217, height: 576, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h1v0-04",
        name: "SQ 04 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 71, width: 1434, height: 576, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h1v0-05",
        name: "SQ 05 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 161, y: 0, width: 1117, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h1v0-06",
        name: "SQ 06 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 851, y: 209, width: 450, height: 300, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h1v0-07",
        name: "SQ 07 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 716, y: 119, width: 720, height: 480, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h1v0-08",
        name: "SQ 08 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 119, width: 720, height: 480, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-09",
        name: "SQ 09 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 1434, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-10",
        name: "SQ 10 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 35, y: 37, width: 1364, height: 644, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-11",
        name: "SQ 11 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 60, width: 1302, height: 598, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-12",
        name: "SQ 12 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 297, y: 79, width: 840, height: 560, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-13",
        name: "SQ 13 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_13.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 1080, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-14",
        name: "SQ 14 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_14.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 360, y: 0, width: 1080, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-15",
        name: "SQ 15 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_15.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 73, width: 857, height: 571, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-16",
        name: "SQ 16 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_16.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 500, y: 73, width: 857, height: 571, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-17",
        name: "SQ 17 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_17.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 108, y: 191, width: 504, height: 336, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-01-h1v0-18",
        name: "SQ 18 - H1V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h1_v0_18.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 825, y: 191, width: 504, height: 336, rotation: 0, imageRotation: 0 },
        ],
    },



];
